'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commandConstants = require('./commandConstants');

var _dependencies = require('../../dependencies');

/**
 * If the editor is empty then fire the empty delete command.
 */
// Constants
var getDeleteCommand = function getDeleteCommand(editorState) {
    return editorState.getCurrentContent().hasText() ? undefined : _commandConstants.EMPTY_DELETE;
};

exports.default = function (event, _ref) {
    var getEditorState = _ref.getEditorState;

    switch (event.keyCode) {
        case _dependencies.KEY_CODES.BACKSPACE:
        case _dependencies.KEY_CODES.DELETE:
            return getDeleteCommand(getEditorState());
        default:
            return;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/deleteOnEmpty/keyBindingFn.js
// module id = 1729
// module chunks = 0